import styled, { css } from 'styled-components';

import { Box } from '@/components/Box';

export const Wrapper = styled(Box)`
  ${({ theme }) => css`
    z-index: ${theme.zIndex.navQuickLinksWithBanner};
    position: relative;
  `}
`;
